import Logo24 from '../../media/logo24.png';

function LoadingModal() {
    return (
        <div className="modal" id="loadingModal">
            <div className="modal-background"></div>
            <div className="modal-content has-text-centered">
                <img alt="Loading..." className="rotate mb-5 mt-5" width="20%" src={Logo24}></img>
            </div>
            <button className="modal-close is-large" aria-label="close"></button>
        </div>
    );
}

export default LoadingModal;